import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support
import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { store, persistor } from './store';
import { CookiesProvider } from 'react-cookie';
import { PersistGate } from 'redux-persist/integration/react';

require('dotenv').config();

console.log('===============', process.env.REACT_APP_ENV, '=================');
console.log('===============', process.env.REACT_APP_IDENTIDADE_URL_TOKEN, '=================');
console.log('===============', process.env.REACT_APP_IDENTIDADE_URL_AUTHORIZE, '=================');
console.log('===============', process.env.REACT_APP_IDENTIDADE_URL_LOGOUT, '=================');
console.log('===============', process.env.REACT_APP_GATEWAY_URL_LOGOUT, '=================');

ReactDOM.render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <CookiesProvider>
                <App />
            </CookiesProvider>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
